import React from 'react';

import { Box, Button, H1, Text } from '@betterment/samba-react';

import { Header } from './Header';

import CheckmarkIcon from '../../images/goal_portfolio_images/custom_path_light.svg';

export const ConfirmAccount: React.FC<{ logoUrl?: string }> = ({ logoUrl }) => {
  const handleContinue = () => {
    // TODO: Wire up to actual flow navigation
    // eslint-disable-next-line no-console
    console.log('Continue clicked');
  };

  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header logoUrl={logoUrl} progress={50} />
      <Box
        css={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 'space.400',
          paddingTop: 'space.800',
        }}
      >
        <Box
          css={{
            marginBottom: 'space.400',
          }}
        >
          <img style={{ width: 64 }} src={CheckmarkIcon} alt="Checkmark in a circle" />
        </Box>

        <Box css={{ textAlign: 'center', pb: 'space.800' }}>
          <H1
            variant="pageTitle"
            css={{
              marginBottom: 'space.150',
              color: 'text.DEFAULT',
            }}
          >
            Finish setting up your solo 401(k) plan
          </H1>
          <Text
            css={{
              fontSize: 'fontSize.100',
              color: 'text.DEFAULT',
              lineHeight: 'lineHeights.normal',
            }}
          >
            Your advisor initiated the process of opening a new Solo 401(k) plan for you. Review and confirm account
            details to complete the process.
          </Text>

          <br />

          <Button
            onClick={handleContinue}
            css={{
              paddingLeft: 'space.300',
              paddingRight: 'space.300',
              marginTop: 'space.300',
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
